/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicLootBoxRewardPreview } from './PublicLootBoxRewardPreview';
import {
    PublicLootBoxRewardPreviewFromJSON,
    PublicLootBoxRewardPreviewFromJSONTyped,
    PublicLootBoxRewardPreviewToJSON,
    PublicLootBoxRewardPreviewToJSONTyped,
} from './PublicLootBoxRewardPreview';

/**
 * 
 * @export
 * @interface PublicLootBoxPrize
 */
export interface PublicLootBoxPrize {
    /**
     * 
     * @type {string}
     * @memberof PublicLootBoxPrize
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicLootBoxPrize
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PublicLootBoxPrize
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof PublicLootBoxPrize
     */
    wonQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof PublicLootBoxPrize
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof PublicLootBoxPrize
     */
    sortOrder: number;
    /**
     * 
     * @type {number}
     * @memberof PublicLootBoxPrize
     */
    onlyAvailableAfterWins?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicLootBoxPrize
     */
    image?: string;
    /**
     * 
     * @type {PublicLootBoxRewardPreview}
     * @memberof PublicLootBoxPrize
     */
    rewardPreview?: PublicLootBoxRewardPreview;
}

/**
 * Check if a given object implements the PublicLootBoxPrize interface.
 */
export function instanceOfPublicLootBoxPrize(value: object): value is PublicLootBoxPrize {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('wonQuantity' in value) || value['wonQuantity'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function PublicLootBoxPrizeFromJSON(json: any): PublicLootBoxPrize {
    return PublicLootBoxPrizeFromJSONTyped(json, false);
}

export function PublicLootBoxPrizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicLootBoxPrize {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'quantity': json['quantity'],
        'wonQuantity': json['wonQuantity'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'sortOrder': json['sortOrder'],
        'onlyAvailableAfterWins': json['onlyAvailableAfterWins'] == null ? undefined : json['onlyAvailableAfterWins'],
        'image': json['image'] == null ? undefined : json['image'],
        'rewardPreview': json['rewardPreview'] == null ? undefined : PublicLootBoxRewardPreviewFromJSON(json['rewardPreview']),
    };
}

export function PublicLootBoxPrizeToJSON(json: any): PublicLootBoxPrize {
    return PublicLootBoxPrizeToJSONTyped(json, false);
}

export function PublicLootBoxPrizeToJSONTyped(value?: PublicLootBoxPrize | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'quantity': value['quantity'],
        'wonQuantity': value['wonQuantity'],
        'weight': value['weight'],
        'sortOrder': value['sortOrder'],
        'onlyAvailableAfterWins': value['onlyAvailableAfterWins'],
        'image': value['image'],
        'rewardPreview': PublicLootBoxRewardPreviewToJSON(value['rewardPreview']),
    };
}

